import { render, staticRenderFns } from "./EventStudentsPopup.vue?vue&type=template&id=cf5112ac&scoped=true"
import script from "./EventStudentsPopup.vue?vue&type=script&lang=js"
export * from "./EventStudentsPopup.vue?vue&type=script&lang=js"
import style0 from "./EventStudentsPopup.vue?vue&type=style&index=0&id=cf5112ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5112ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf5112ac')) {
      api.createRecord('cf5112ac', component.options)
    } else {
      api.reload('cf5112ac', component.options)
    }
    module.hot.accept("./EventStudentsPopup.vue?vue&type=template&id=cf5112ac&scoped=true", function () {
      api.rerender('cf5112ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EventStudentsPopup.vue"
export default component.exports